import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { TrackingFacadeService } from 'src/app/services/tracking/tracking-facade.service';
import { ModalComponent } from '../modal.component/modal.component';

@Component({
  selector: 'app-how-to-play-modal',
  templateUrl: './how-to-play-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./how-to-play-modal.component.scss'],
})
export class HowToPlayModalComponent {
  @ViewChild('modal') public modal: ModalComponent;

  public constructor(
      private trackingFacadeService: TrackingFacadeService) { }

  public open() {
    const path = window.location.href;
    this.trackingFacadeService.virtualPageView(path, 'Sådan fungerer det modal');
    this.modal.open();
  }
  
  public closeModal() {
    this.modal.close();
  }
}
